import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { isNull, oneMonthBeforeToday } from "App/utils/helpers";
import moment from "moment";
import {
  STATUS_TRANSAKSI_DRAFT,
  STATUS_TRANSAKSI_PENGAJUAN,
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENAWARAN,
  STATUS_TRANSAKSI_TRIAL,
  STATUS_TRANSAKSI_PENGAJUAN_PO,
  STATUS_TRANSAKSI_PENGADAAN,
  STATUS_TRANSAKSI_SELESAI,
  STATUS_TRANSAKSI_REVISI,
  STATUS_TRANSAKSI_REJECT,
} from "../InputRequest/helpers";
import React from "react";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = "/wmsAsset/request/list-pengajuan-request";
export const urlDelete = "/wmsAsset/request/delete";

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id_request: "",
  nama_request: "",
  status_kebutuhan: "",
  nama_status_kebutuhan: "Pilih Status",
  unit_id: null,
  unit: "Pilih Unit",
  status_verifikasi: null,
  nama_status_verifikasi: "Pilih Status",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: moment(new Date()).local().toDate(),
};

export const getByFilterReq = async (
  formFilter,
  pages,
  limit,
  alwaysPengadaan = false,
  url = urlGet,
  type= null,
) => {
  try {
    const api = await instance4.post(url, {
      halaman: pages,
      jumlah: limit,
      kategori: isNull(type) ? '' : type,
      id_request: formFilter.id_request,
      nama_request: formFilter.nama_request,
      status_kebutuhan: formFilter.status_kebutuhan,
      unit_id: formFilter.unit_id,
      status_verifikasi: alwaysPengadaan ? 3 : formFilter.status_verifikasi,
      tglAwal: startOfDay(formFilter.tglAwal),
      tglAkhir: lastOfDay(formFilter.tglAkhir),
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePoById = async (id) => {
  try {
    const api = await instance4.post(urlDelete, { id }, {});
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus Request",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "unit",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_kebutuhan",
    disablePadding: false,
    label: "STATUS KEBUTUHAN",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "user_request",
    disablePadding: false,
    label: "USERNAME REQUEST",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jml_req_barang",
    disablePadding: false,
    label: "JUMLAH BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_verifikasi",
    disablePadding: false,
    label: "STATUS VERIFIKASI",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_verifikasi",
    disablePadding: false,
    label: "TGL VERIFIKASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "user_verifikasi",
    disablePadding: false,
    label: "USER VERIFIKASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remak_verifikasi",
    disablePadding: false,
    label: "CATATAN VERIFIKASI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "tgl_permintaan",
    disablePadding: false,
    label: "TGL PERMINTAAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusVerifikasiBadge = ({ status }) => {
  if (status === STATUS_TRANSAKSI_DRAFT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DRAFT"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_DISETUJUI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DISETUJUI MANAGER UNIT"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PENAWARAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENAWARAN"}
        color={"lightgreen"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_TRIAL) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"TRIAL"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PENGAJUAN_PO) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN PO"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PENGADAAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PROSES PO"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"primary"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_REVISI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"REVISI"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_REJECT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DITOLAK"}
        color={"danger"}
        type='button'
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};

export const RenderStatusKebutuhanBadge = ({ status }) => {
  if (status === 1) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"NORMAL"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else if (status === 2) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"MEDIUM"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === 3) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"URGENT"}
        color={"danger"}
        type='button'
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan</p>;
  }
};
